export default function Hobbies() {
    return (
        <div id="Hobbies" className="Hobbies" data-aos="fade-up" data-aos-duration="2000">
            <br />
            <h3 className="text-center">Hobbies</h3>
            <br />
            <br />
           <ul>
              <li>
                Reading books, technical blogs, algorithm books.
             </li>
              <li>
                Solving puzzles and math riddles.
             </li>
            <li>
              Automating manual tasks [<a href="https://github.com/Nimitha-jagadeesha/Automation-Scripts">Github Repo</a>]
            </li>
          </ul>
            <br />
        </div>
    )
}
